import Header from 'modules/header/farm/main';
import useGetSaleType from './hooks/useGetSaleType';
import {useLocation} from 'react-router-dom';
import CategoryList from 'components/categoryList/typeSale';
import TypeAdsHelp from 'components/typeAdsHelp';
import {useFarm} from 'context/farmContext';
import {useCookies} from 'react-cookie';
import {useEffect} from 'react';
const TypeAds = () => {
  const location = useLocation();
  const {updateCultivationGuid, updateCultivationArea} = useFarm();
  const [cookie] = useCookies(['cultivationGuid']);
  const {isLoading, farmTypeSales} = useGetSaleType(
    location?.state?.cultivationGuid
      ? location?.state?.cultivationGuid
      : cookie?.cultivationGuid
      ? cookie.cultivationGuid.guid
      : '',
  );
  useEffect(() => {
    if (cookie.cultivationGuid) {
      updateCultivationGuid(
        cookie.cultivationGuid.guid,
        cookie.cultivationGuid.subProduct,
      );
      updateCultivationArea({
        area: cookie.cultivationGuid.area,
        harvest_datetime: cookie.cultivationGuid.harvestDateTime,
      });
    }
  }, [cookie]);
  return (
    <>
      <Header title="نوع آگهی" />
      {!isLoading && <CategoryList list={farmTypeSales} appType="farm" />}
      <div className="pb-[8vh]">
        <TypeAdsHelp app="farm" />
      </div>
    </>
  );
};

export default TypeAds;
